import { invoiceFromBooking } from "./invoice";
import { CONTACT_NUMBER } from "../mock";

const waPhone = (phone) => {
  const d = String(phone || "").replace(/\D/g, "").replace(/^0+/, "");
  return d.length === 10 ? `91${d}` : d;
};

export const whatsappReceiptUrl = (b) => {
  const inv = invoiceFromBooking(b);
  const id = b.booking_id.replace(/^AIP-/, "");
  const amt = `${b.currency || "INR"} ${inv.total.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`;
  const text = [
    `Dear ${b.guest_first_name}, thank you for staying at ${b.hotel_name}.`,
    "",
    `Booking No: ${id}`,
    `Room: ${b.room_type} × ${b.rooms}`,
    `Stay: ${b.check_in} to ${b.check_out} (${b.nights} night${b.nights > 1 ? "s" : ""})`,
    `Total: *${amt}* · ${b.payment_status === "paid" ? `Paid (${b.payment_method})` : "Payment pending"}`,
    "",
    `View / download receipt: ${window.location.origin}/receipt/${id}`,
    `Help: ${b.hotel_phone || CONTACT_NUMBER}`,
  ].join("\n");
  return `https://wa.me/${waPhone(b.phone)}?text=${encodeURIComponent(text)}`;
};
